export default __webpack_public_path__ + "static/media/2logo.0339d0db.png";